import React from 'react'
import styles from './Badge.module.css'

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral'

export interface BadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  style?: React.CSSProperties
}

export function Badge({ variant = 'neutral', children, style }: BadgeProps) {
  return <span className={`${styles.badge} ${styles[variant]}`} style={style}>{children}</span>
}

export function getStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'Active': return 'success'
    case 'On Hold': return 'warning'
    case 'Closed': return 'neutral'
    case 'Tentative': return 'info'
    default: return 'neutral'
  }
}
